import TextInput from "./TextInput";
import { Trans } from "../utils/i18n";
import React, { useState } from "react";
import { Field, Form as FinalForm } from "react-final-form";
import styled from "styled-components";
import Select from "./Select";
import { usePage } from "@inertiajs/inertia-react";
import MuiButton from "@material-ui/core/Button";
import { Inertia } from "@inertiajs/inertia";

const FieldWrapper = styled.div`
    margin-bottom: 10px;
`;

export function AddressShowEdit({ order, setEditAddress, type }) {
    const { countries } = usePage().props;

    const onSubmit = (values) => {
        Inertia.post(
            route("queue.updateAddress", {
                order: order.order_id,
                type: type,
            }),
            {
                data: values,
                type: type,
            },
            {
                preserveState: true,
                preserveScroll: true,
                onSuccess: () => {
                    setEditAddress(false);
                },
            }
        );
    };

    let initialValues = {};

    if (type === "installation_address" || type === "contact") {
        initialValues = order.installation_address;
    }

    if (type === "delivery_address" || type === "delivery_contact") {
        initialValues = order.delivery_address;
    }

    if (type === "collection_address" || type === "collection_contact") {
        initialValues = order.collection_address;
    }

    if (type === "invoice_address" || type === "invoice_contact") {
        initialValues = order.invoice_address;
    }

    return (
        <div>
            <FinalForm onSubmit={onSubmit} initialValues={initialValues}>
                {({
                    handleSubmit,
                    submitting,
                    values,
                    form,
                    errors,
                    touched,
                }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            {(type === "installation_address" ||
                                type === "delivery_address" ||
                                type === "collection_address" ||
                                type === "invoice_address") && (
                                <>
                                    <FieldWrapper>
                                        <Field
                                            name={"name"}
                                            component={TextInput}
                                            field={{
                                                label: (
                                                    <Trans i18nKey="orderEntry.addressContact.address1">
                                                        Address 1.
                                                    </Trans>
                                                ),
                                                type: "text",
                                                size: "small",
                                            }}
                                            disabled={submitting}
                                        />
                                    </FieldWrapper>
                                    <FieldWrapper>
                                        <Field
                                            name={"name_2"}
                                            component={TextInput}
                                            field={{
                                                label: (
                                                    <Trans i18nKey="orderEntry.addressContact.address2">
                                                        Address 2.
                                                    </Trans>
                                                ),
                                                type: "text",
                                                size: "small",
                                            }}
                                            disabled={submitting}
                                        />
                                    </FieldWrapper>
                                    <FieldWrapper>
                                        <Field
                                            name={"street"}
                                            component={TextInput}
                                            field={{
                                                label: (
                                                    <Trans i18nKey="orderEntry.addressContact.street">
                                                        Street
                                                    </Trans>
                                                ),
                                                type: "text",
                                                size: "small",
                                            }}
                                            disabled={submitting}
                                        />
                                    </FieldWrapper>
                                    <FieldWrapper>
                                        <Field
                                            name={"housenumber"}
                                            component={TextInput}
                                            field={{
                                                label: (
                                                    <Trans i18nKey="orderEntry.addressContact.housenumber">
                                                        House number
                                                    </Trans>
                                                ),
                                                type: "text",
                                                size: "small",
                                            }}
                                            disabled={submitting}
                                        />
                                    </FieldWrapper>
                                    <FieldWrapper>
                                        <Field
                                            name={"zip"}
                                            component={TextInput}
                                            field={{
                                                label: (
                                                    <Trans i18nKey="orderEntry.addressContact.zip">
                                                        ZIP
                                                    </Trans>
                                                ),
                                                type: "text",
                                                size: "small",
                                            }}
                                            disabled={submitting}
                                        />
                                    </FieldWrapper>
                                    <FieldWrapper>
                                        <Field
                                            name={"city"}
                                            component={TextInput}
                                            field={{
                                                label: (
                                                    <Trans i18nKey="orderEntry.addressContact.city">
                                                        City
                                                    </Trans>
                                                ),
                                                type: "text",
                                                size: "small",
                                            }}
                                            disabled={submitting}
                                        />
                                    </FieldWrapper>
                                    <FieldWrapper>
                                        <Field
                                            name={"country_id"}
                                            type={"select"}
                                            component={Select}
                                            field={{
                                                label: (
                                                    <Trans i18nKey="orderEntry.addressContact.country">
                                                        Country
                                                    </Trans>
                                                ),
                                                type: "text",
                                                size: "small",
                                                variant: "standard",
                                                disableUnselected: true,
                                                options: countries.map(
                                                    (item) => ({
                                                        value: item.id,
                                                        label: item.name,
                                                    })
                                                ),
                                            }}
                                            disabled={submitting}
                                        />
                                    </FieldWrapper>
                                </>
                            )}
                            {(type === "contact" ||
                                type === "delivery_contact" ||
                                type === "collection_contact" ||
                                type === "invoice_contact") && (
                                <>
                                    <FieldWrapper>
                                        <Field
                                            name={"phone"}
                                            component={TextInput}
                                            field={{
                                                label: (
                                                    <Trans i18nKey="orderEntry.addressContact.phone">
                                                        Phone number
                                                    </Trans>
                                                ),
                                                type: "text",
                                                size: "small",
                                            }}
                                            disabled={submitting}
                                        />
                                    </FieldWrapper>
                                </>
                            )}
                            {type === "contact" && (
                                <>
                                    <FieldWrapper>
                                        <Field
                                            name={"mobile"}
                                            component={TextInput}
                                            field={{
                                                label: (
                                                    <Trans i18nKey="orderEntry.addressContact.mobile">
                                                        Mobile number
                                                    </Trans>
                                                ),
                                                type: "text",
                                                size: "small",
                                            }}
                                            disabled={submitting}
                                        />
                                    </FieldWrapper>
                                </>
                            )}
                            {(type === "contact" ||
                                type === "delivery_contact" ||
                                type === "collection_contact" ||
                                type === "invoice_contact") && (
                                <>
                                    <FieldWrapper>
                                        <Field
                                            name={"email"}
                                            component={TextInput}
                                            field={{
                                                label: (
                                                    <Trans i18nKey="orderEntry.addressContact.email">
                                                        E-Mail Address
                                                    </Trans>
                                                ),
                                                type: "text",
                                                size: "small",
                                            }}
                                            disabled={submitting}
                                        />
                                    </FieldWrapper>
                                </>
                            )}

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                }}
                            >
                                <MuiButton
                                    variant="contained"
                                    color={"primary"}
                                    disabled={submitting}
                                    size={"small"}
                                    onClick={() => {
                                        setEditAddress(false);
                                    }}
                                >
                                    <Trans i18nKey="common.cancel">
                                        Cancel
                                    </Trans>
                                </MuiButton>
                                <MuiButton
                                    variant="contained"
                                    color={"secondary"}
                                    disabled={submitting}
                                    size={"small"}
                                    style={{ marginLeft: 15 }}
                                    type={"submit"}
                                >
                                    <Trans i18nKey="common.save">Save</Trans>
                                </MuiButton>
                            </div>
                        </form>
                    );
                }}
            </FinalForm>
        </div>
    );
}
